import { Currencies } from '@/entities/curency'
import { selectRatesInfo } from '@/entities/exchangeRates'
import { formatCurrency } from '@/shared/lib/currency'
import { StatisticTabNames } from '@/shared/lib/models/tabsStatisticOptions'
import { useSelector } from 'react-redux'

type Props = {
  paidAmountSum: number
  className?: string
  type: StatisticTabNames
}

export const AmountInfo = ({ paidAmountSum, className, type }: Props) => {
  const { payInRate, payOutRate, lastUpdatedShort } = useSelector(selectRatesInfo)
  const rate = parseFloat((type === 'payIn' ? payInRate : payOutRate).replace('RUB', '').trim())

  const amount = formatCurrency(paidAmountSum ?? 0, Currencies.USDT)
  const amountUsdt = formatCurrency((paidAmountSum ?? 0) * rate, Currencies.RUB)

  return (
    <div className={`flex flex-col w-fit ${className}`}>
      <div className="font-klein font-medium text-text-main md:text-[28px] dark:text-white text-2xl">
        <span>{amount}</span>
      </div>
      <div className="mb-2 text-text-main dark:text-white text-sm md:text-base">
        <span className="mr-2">~ {amountUsdt}</span>
        <span className="text-text-secondary">
          по курсу {type === 'payIn' ? payInRate : payOutRate} на {lastUpdatedShort}
        </span>
      </div>
    </div>
  )
}
